import { TablePreset } from '@/types';

const presets: TablePreset[] = [];

export default presets;
